import { render } from "./SettingsPersonalInformation.vue?vue&type=template&id=f8248d38"
import script from "./SettingsPersonalInformation.vue?vue&type=script&lang=js"
export * from "./SettingsPersonalInformation.vue?vue&type=script&lang=js"
script.render = render

export default script